import React from 'react';
import Icon from '@mdi/react';
import { Box, CircularProgress } from '@mui/material';

export default ({ icon, loading = true }: { icon: string; loading?: boolean }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', m: '12px' }}>
            <Icon path={icon} size={1} style={{ position: 'absolute' }} />
            {loading && (
                <CircularProgress
                    sx={{
                        position: 'absolute',
                        zIndex: 1,
                    }}
                />
            )}
        </Box>
    );
};
